/* URSA swatch gallery preview (testing theme, 6 Oct 2026, premium motion pack idea 1).
   Hovering a Colour swatch on a product page fades the main product photo to that colour, with a small
   colour label, and fades back when the pointer leaves. Moving between swatches cross-fades.
   If the main photo is scrolled out of view, the small popup (ursa-variant-preview.js) is used instead.
   Remove: delete the ursa-swatch-gallery.js line in layout/theme.liquid. */
(function () {
  if (window.__ursaSG) return;
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.22,.61,.36,1)';
  var DELAY = 120, WARM = 450, GRACE = 160;
  var SEL = 'variant-picker .variant-option__button-label';

  var css = '.ursa-sg{position:absolute;z-index:4;pointer-events:none;background:#fff;opacity:0;transition:opacity .32s ease}' +
    '.ursa-sg.is-on{opacity:1;transition:opacity .5s ' + EASE + '}' +
    '.ursa-sg img{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;opacity:0;transform:scale(1.015);transition:opacity .45s ' + EASE + ',transform .9s ' + EASE + '}' +
    '.ursa-sg img.is-cur{opacity:1;transform:none}' +
    '.ursa-sg b{position:absolute;left:16px;bottom:16px;background:rgba(255,255,255,.92);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);color:#1b2753;font-size:12px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;padding:7px 12px;border-radius:999px;box-shadow:0 4px 14px rgba(27,39,83,.12);opacity:0;transform:translateY(6px);transition:opacity .35s ' + EASE + ' .1s,transform .45s ' + EASE + ' .1s}' +
    '.ursa-sg.is-on b{opacity:1;transform:none}' +
    (reduce ? '.ursa-sg,.ursa-sg img,.ursa-sg b{transition:opacity .15s linear!important;transform:none!important}' : '');
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var cache = {}, layer = null, imgs = [], tag = null, which = 0;
  var current = null, showT = 0, hideT = 0, hiddenAt = 0, tok = 0;

  function gallery() { return document.querySelector('media-gallery'); }
  function slideImg(g) {
    var s = g.querySelector('slideshow-slide[aria-hidden="false"] img') || g.querySelector('slideshow-slide img') || g.querySelector('img');
    return s;
  }
  function galleryVisible() {
    var g = gallery(); if (!g) return false;
    var im = slideImg(g); if (!im) return false;
    var r = im.getBoundingClientRect();
    return r.width > 200 && r.bottom > 140 && r.top < window.innerHeight - 140;
  }
  function isColour(el) {
    var i = el.querySelector('input');
    return !!i && /^colou?r-/i.test(i.name || '') && !!el.closest('variant-picker') && !el.closest('product-card');
  }
  window.__ursaSG = { owns: function (el) { return isColour(el) && galleryVisible(); } };

  function getJSON(url) {
    var u = url.split('?')[0].split('#')[0].replace(/\/$/, '') + '.js';
    if (!cache[u]) cache[u] = fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return cache[u];
  }
  function resolve(el) {
    var picker = el.closest('variant-picker'), input = el.querySelector('input');
    var pos = parseInt((input.getAttribute('data-input-id') || '').split('-')[0], 10);
    if (!picker || !pos) return Promise.resolve(null);
    return getJSON(picker.getAttribute('data-product-url') || location.pathname).then(function (p) {
      if (!p) return null;
      var want = [];
      picker.querySelectorAll('fieldset.variant-option input[type=radio]:checked').forEach(function (i) {
        var n = parseInt((i.getAttribute('data-input-id') || '').split('-')[0], 10);
        if (n) want[n - 1] = i.value;
      });
      want[pos - 1] = input.value;
      var v = p.variants.filter(function (x) { return want.every(function (w, k) { return w == null || x.options[k] === w; }); })[0] ||
        p.variants.filter(function (x) { return x.options[pos - 1] === input.value; })[0];
      var s = v && v.featured_image && v.featured_image.src;
      return s ? { src: s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=1400', label: input.value } : null;
    });
  }
  function build(g) {
    if (layer && layer.parentNode === g) return;
    layer = document.createElement('div'); layer.className = 'ursa-sg'; layer.setAttribute('aria-hidden', 'true');
    imgs = [new Image(), new Image()]; imgs.forEach(function (i) { i.alt = ''; layer.appendChild(i); });
    tag = document.createElement('b'); layer.appendChild(tag);
    g.appendChild(layer);
  }
  function fit(g) {
    var im = slideImg(g), gr = g.getBoundingClientRect(), r = im.getBoundingClientRect();
    layer.style.left = (r.left - gr.left) + 'px'; layer.style.top = (r.top - gr.top) + 'px';
    layer.style.width = r.width + 'px'; layer.style.height = r.height + 'px';
  }
  function isOn() { return !!layer && layer.classList.contains('is-on'); }
  function warm() { return isOn() || Date.now() - hiddenAt < WARM; }
  function hideNow() {
    clearTimeout(showT); clearTimeout(hideT); tok++;
    if (isOn()) hiddenAt = Date.now();
    current = null;
    if (layer) layer.classList.remove('is-on');
  }
  function leave() { clearTimeout(showT); clearTimeout(hideT); current = null; tok++; hideT = setTimeout(hideNow, GRACE); }
  function display(el, d) {
    var g = gallery(); if (!g) return;
    var my = ++tok, pre = new Image();
    pre.onload = function () {
      if (my !== tok || current !== el) return;
      build(g); fit(g);
      var cur = imgs[which];
      if (isOn() && cur.getAttribute('src') === d.src) { tag.textContent = d.label; return; }
      if (!isOn()) { imgs.forEach(function (i) { i.classList.remove('is-cur'); }); }
      var next = imgs[which = 1 - which];
      next.src = d.src;
      tag.textContent = d.label;
      void layer.offsetWidth;
      imgs[1 - which].classList.remove('is-cur');
      next.classList.add('is-cur');
      layer.classList.add('is-on');
    };
    pre.src = d.src;
  }

  document.addEventListener('mouseover', function (e) {
    var el = e.target.closest && e.target.closest(SEL);
    if (!el) return;
    if (el === current) { clearTimeout(hideT); return; }
    if (!isColour(el) || !galleryVisible()) { if (current || isOn()) leave(); return; }
    clearTimeout(hideT); clearTimeout(showT);
    current = el;
    var data = resolve(el);
    showT = setTimeout(function () {
      data.then(function (d) { if (current !== el) return; if (!d) { hideNow(); return; } display(el, d); });
    }, warm() ? 0 : DELAY);
  });
  document.addEventListener('mouseout', function (e) {
    var el = e.target.closest && e.target.closest(SEL);
    if (el && el === current && !el.contains(e.relatedTarget)) leave();
  });
  /* choosing the colour: the real gallery switches underneath, so just fade the layer away */
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest(SEL)) { hideNow(); hiddenAt = 0; } }, true);
  window.addEventListener('resize', function () { if (isOn()) hideNow(); });
})();
